module.exports = __webpack_public_path__ + "img/logo.d3387b1a.svg";